import { useState, useRef } from 'react';
import { Input } from '@/shared/components/ui/input';
import type { TaskDetail, UpdateTaskDetailPayload } from '../../types';

interface TaskTitleEditorProps {
  task: TaskDetail;
  onUpdate: (patch: UpdateTaskDetailPayload) => void;
}

export function TaskTitleEditor({ task, onUpdate }: TaskTitleEditorProps) {
  const [editingTitle, setEditingTitle] = useState(false);
  const [title, setTitle] = useState(task.title);
  const originalTitleRef = useRef(task.title);

  function startEdit() {
    originalTitleRef.current = task.title;
    setTitle(task.title);
    setEditingTitle(true);
  }

  function commitTitle() {
    setEditingTitle(false);
    const trimmed = title.trim();
    if (trimmed && trimmed !== originalTitleRef.current) onUpdate({ title: trimmed });
    else setTitle(originalTitleRef.current);
  }

  function cancelTitle() {
    setEditingTitle(false);
    setTitle(originalTitleRef.current);
  }

  return (
    <div>
      {editingTitle ? (
        <Input
          autoFocus
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          onBlur={commitTitle}
          onKeyDown={(e) => {
            if (e.key === 'Enter') e.currentTarget.blur();
            else if (e.key === 'Escape') cancelTitle();
          }}
          data-testid="tasks-dialog-title-input"
          className="h-auto border-0 px-0 text-xl font-semibold shadow-none focus-visible:ring-0"
        />
      ) : (
        <h2
          onClick={startEdit}
          data-testid="tasks-dialog-title"
          className="cursor-text text-xl font-semibold hover:opacity-80"
        >
          {task.title}
        </h2>
      )}
    </div>
  );
}
